/**
 * Host-side correlation ID source.
 *
 * Centralizes how the host learns its hierarchical IDs so the trace-attach
 * helper can stamp them onto every outbound WebSocket message without each
 * call site needing to know where the IDs come from:
 *   - machine_id   : always known once the machine identifies (machineIdState)
 *   - broadcast_id : the host's assigned HOST peer id, set when the realtime
 *                    connection receives/recovers it (late-bound)
 *
 * Single responsibility: expose the current correlation IDs and let the
 * realtime module update broadcast_id as it becomes known.
 */

import type { CorrelationIds } from '@playcastdotio/Observability';
import { machineIdState } from '../../stores/shared';

let hostBroadcastId: string | undefined;

/** Record (or clear) the host's broadcast id (its HOST peer id). */
export const setHostBroadcastId = (broadcastId: string | undefined): void => {
  hostBroadcastId = broadcastId || undefined;
};

/** Current host correlation IDs; only defined values are stamped downstream. */
export const getHostCorrelationIds = (): CorrelationIds => ({
  machineId: machineIdState.currentState || undefined,
  broadcastId: hostBroadcastId,
});
